import { module } from "angular";
import { UnauthorizedModalComponent } from "./UnauthorizedModalComponent";

module("mmAuth").component("irUnauthorizedModal", new UnauthorizedModalComponent());
